'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';

interface ExportExcelConfigProps {
  nodeId: string;
  config: { fileName?: string; sheetName?: string };
}

export function ExportExcelConfig({ nodeId, config }: ExportExcelConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [fileName, setFileName]   = useState(config.fileName  || 'output');
  const [sheetName, setSheetName] = useState(config.sheetName || 'Sheet1');

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, { type: 'export_excel', params: { fileName, sheetName, ...updates } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">文件名（不含扩展名）</label>
        <input type="text" placeholder="output" value={fileName}
          onChange={(e) => { setFileName(e.target.value); save({ fileName: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 placeholder:text-zinc-400"
        />
        <p className="text-xs text-zinc-400">最终下载文件为 <code className="bg-zinc-100 px-1 rounded">{fileName || 'output'}.xlsx</code></p>
      </div>
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">工作表名称</label>
        <input type="text" placeholder="Sheet1" value={sheetName}
          onChange={(e) => { setSheetName(e.target.value); save({ sheetName: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 placeholder:text-zinc-400"
        />
      </div>
    </div>
  );
}
